import React from 'react';

export const GradientDefs = () => (
  <svg style={{ height: 0 }}>
    <defs>
      {/* 1. Gradient 308.09deg */}
      <linearGradient id="gradientId0" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="14.91%" stopColor="#52D5FF" />
        <stop offset="77%" stopColor="#0047FF" />
      </linearGradient>

      {/* 5. Gradient 121.05deg */}
      <linearGradient id="gradientId1" x1="20%" y1="100%" x2="100%" y2="0%">
        <stop offset="17.81%" stopColor="#4E64F2" />
        <stop offset="80.51%" stopColor="#E54CFF" />
      </linearGradient>

      {/* 2. Gradient 308.09deg */}
      <linearGradient id="gradientId2" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="38.41%" stopColor="#90E7F1" />
        <stop offset="68.11%" stopColor="#29B9BE" />
      </linearGradient>

      {/* 3. Gradient 308.93deg */}
      <linearGradient id="gradientId3" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="15.14%" stopColor="#C8F29B" />
        <stop offset="117.27%" stopColor="#00D6BB" />
      </linearGradient>

      {/* 4. Gradient 102.13deg */}
      <linearGradient id="gradientId4" x1="15%" y1="100%" x2="85%" y2="0%">
        <stop offset="14.91%" stopColor="#FF3729" />
        <stop offset="77.01%" stopColor="#FF6851" />
      </linearGradient>      

      {/* 6. Gradient 121.05deg */}
      <linearGradient id="gradientId5" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="26.28%" stopColor="#FF9655" />
        <stop offset="87.7%" stopColor="#FFC529" />
      </linearGradient>
      
    </defs>
  </svg>

);

export default GradientDefs;

export const MetricColors = [
  {
    id: 0,
    metricNotMet: '#0047FF',
    metricMet: '#52D5FF',
    textColor:'#0047FF',
    bgColor: '#DBECFD', // light version of #52D5FF
    outerCircleColorId:1,
    clientTargetTextColor:'#6710B8',
    ScorecardTargetColor:'#1A5AA5',
  },
  {
    id: 1,
    metricNotMet: '#4E64F2',
    metricMet: '#E54CFF',
    textColor:'#4E64F2',
    bgColor:'#f9f0ff', // light version of #E54CFF
    outerCircleColorId:0,
    clientTargetTextColor:'#1A5AA5',
    ScorecardTargetColor:'#6710B8',
  },
  {
    id: 2,
    metricNotMet: '#29B9BE',
    metricMet: '#90E7F1',
    textColor:'#29B9BE',
    bgColor:'#E6F9FB', // light version of #90E7F1
    outerCircleColorId:3,
    clientTargetTextColor:'#2AA154',
    ScorecardTargetColor:'#00B6B2',
  },
  {
    id: 3,
    metricNotMet: '#00D6BB',
    metricMet: '#C8F29B',
    textColor:'#00D6BB',
    bgColor:'#F1FCE6', // light version of #C8F29B
    outerCircleColorId:2,
    clientTargetTextColor:'#00B6B2',
    ScorecardTargetColor:'#2AA154',
  },
  {
    id: 4,
    metricNotMet: '#FF9655',
    metricMet: '#FFC727',
    textColor:'#FF9655',
    bgColor:'#FFF1DE', // light version of #FFC727
    outerCircleColorId:5,
    clientTargetTextColor:'#E37D16',
    ScorecardTargetColor:'#F15523',
  },
  {
    id: 5,
    metricNotMet: '#8B234B',
    metricMet: '#EF74CC',
    textColor:'#8B234B',
    bgColor:'#FDE0F1', // lighter version of #EF74CC
    outerCircleColorId:4,
    clientTargetTextColor:'#F15523',
    ScorecardTargetColor:'#E37D16',
  }
];
